import events from '~/modules/game-events/game-events';
import { useEventEffect } from '~/modules/game-events/hooks';
import PlayersManager from '~/modules/players/players-manager';
import { useMicrophoneList } from '~/routes/select-input/hooks/use-microphone-list';
import { MicrophoneInputSource } from '~/routes/select-input/input-sources/microphone';

/**
 * A SingStar pair is two channels of one device that `microphone.ts` has already recognised and
 * tagged with the player it belongs to (`preferred`), so plugging one in fills the two slots on its
 * own — the setup screen has no step to walk through for it.
 *
 * Never takes a slot away from a phone: a room that has assigned phones and then plugs a SingStar
 * mic in for the music must keep its phones. A slot on a local mic is fair game — it is either the
 * default the setup screen claimed on arrival, or a lesser device than the pair now plugged in.
 */
export function useSingstarAutoselect() {
  const { Microphone } = useMicrophoneList(true, 'Microphone');

  useEventEffect(events.inputListChanged, () => {
    const preferred = Microphone.list.filter((input) => input.preferred !== undefined);

    if (preferred.length !== 2 || preferred[0].deviceId !== preferred[1].deviceId) return;

    preferred.forEach((input) => {
      const player = PlayersManager.getPlayer(input.preferred!);
      if (!player) return;

      if (player.input.source === 'Remote Microphone') return;

      player.changeInput(MicrophoneInputSource.inputName, input.channel, input.deviceId);
    });
  });
}
